<template>
    <v-modal-validated title="Añadir un nuevo usuario"
                       accept-button-text="Guardar"
                       close-button-text="Cerrar"
                       :rules="rules"
                       id="add-user-modal"
                       @closed="closeModal"
                       @accepted="addUser">
        <div class="user-form row">
            <div class="form-group col-6">
                <label>Nombre:</label>
                <Field type="text" name="name" class="form-control" v-model="user.name"/>

                <ErrorMessage name="name"/>
            </div>

            <div class="form-group col-6">
                <label>Email:</label>
                <Field type="email" name="email" class="form-control" v-model="user.email"/>

                <ErrorMessage name="email"/>
            </div>

            <div class="form-group col-6">
                <label>Contraseña:</label>
                <Field type="password" name="password" class="form-control" v-model="user.password"/>

                <ErrorMessage name="password"/>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <span class="badge bg-success" v-if="!!user.password && user.password.length >= 3">Esta será la nueva contraseña</span>
                <span class="badge bg-warning" v-if="!!user.password && user.password.length < 3">3 caracteres mínimo</span>
                <span class="badge bg-danger" v-if="!user.password">Contraseña necesaria</span>
            </div>
            <div class="col-12">
                <p>Este usuario tendrá el rol <strong>Atención al cliente</strong> por defecto, luego podrás editarlo.</p>
            </div>
        </div>
    </v-modal-validated>
</template>

<script>

import {createUser} from "../../../helpers/requests/RequestsUsers";
import VModalValidated from "../../general/VModalValidated";
import * as yup from "yup";
import {ErrorMessage, Field, Form} from "vee-validate";

export default {
    name: "UsersListAddModal",
    components: {
        VModalValidated,
        Form,
        Field,
        ErrorMessage
    },
    data() {
        const rules = yup.object({
            name: yup.string().required('Debes incluir un nombre'),
            email: yup.string().email('Debes introducir un correo válido').required('Debes incluir un correo electrónico'),
            password: yup.string().required('Debes incluir una contraseña'),
        });

        return {
            user: {},
            errors: [],
            modal: null,

            rules
        }
    },
    methods: {
        async addUser(data) {
            try {
                await createUser(data);

                this.$store.dispatch('app/setToastMessage', 'Usuario añadido');

                this.closeModal();
            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al crear el usuario');
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    },
}
</script>
